import { render, staticRenderFns } from "./CheckoutProductsComponent.vue?vue&type=template&id=07a8df2a"
import script from "./CheckoutProductsComponent.vue?vue&type=script&lang=js"
export * from "./CheckoutProductsComponent.vue?vue&type=script&lang=js"
import style0 from "./CheckoutProductsComponent.vue?vue&type=style&index=0&id=07a8df2a&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports